
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supports",
      function () {
        return require("private-next-pages/supports.tsx");
      }
    ]);
  